import { render, staticRenderFns } from "./FormLessons.vue?vue&type=template&id=0079b8e0&scoped=true"
import script from "./FormLessons.vue?vue&type=script&lang=js"
export * from "./FormLessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079b8e0",
  null
  
)

export default component.exports